import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslationService, WindowRef } from '@spartacus/core';
import { Card, CardModule } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import moment from 'moment';
import { GenEngineReplacementForm } from 'src/app/generac/models/checkout.model';
import { Order } from '@spartacus/order/root';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'gen-order-engine-replacement-form',
  templateUrl: './order-engine-replacement-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CardModule]
})
export class GenOrderEngineReplacementFormComponent {
  order: Order;
  isServicePartsEnabled: boolean;

  @Input('order')
  set setOrder(order: Order) {
    this.order = order;
  }

  constructor(
    protected translationService: TranslationService,
    protected winRef: WindowRef,
  ) {
  }

  getEngineReplacementModelNumberCard(engineModelNumber: string): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.modelNumberDestroyed'),
    ]).pipe(
      map(([textTitle]) => {
        return {
          title: textTitle,
          text: [
            engineModelNumber
          ],
        } as Card;
      })
    );
  }

  getEngineReplacementSerialNumberCard(engineSerialNumber: string): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.serialNumberDestroyed'),
    ]).pipe(
      map(([textTitle]) => {
        return {
          title: textTitle,
          text: [
            engineSerialNumber
          ],
        } as Card;
      })
    );
  }

  getEngineReplacementAccountIdCard(accountId: string): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.accountId'),
    ]).pipe(
      map(([textTitle]) => {
        return {
          title: textTitle,
          text: [
            accountId
          ],
        } as Card;
      })
    );
  }

  getEngineReplacementPurchaseDateCard(purchaseDate: string): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.purchaseDate'),
    ]).pipe(
      map(([textTitle]) => {
        return {
          title: textTitle,
          text: [
            moment(purchaseDate).format('MM.DD.YYYY')
          ],
        } as Card;
      })
    );
  }

  getEngineReplacementAttestationCheckboxesCard(replacementReason: string): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.attestationCheckboxesTitle'),
      this.translationService.translate('checkoutProgress.engineReplacementForm.attestationCheckboxesOptions.' + replacementReason),
    ]).pipe(
      map(([textTitle, replacementReason]) => {
        return {
          title: textTitle,
          text: [
            replacementReason
          ],
        } as Card;
      })
    );
  }

  getEngineReplacementPurchasingUserCard(purchasingUser: string): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.purchasingUser'),
    ]).pipe(
      map(([textTitle]) => {
        return {
          title: textTitle,
          text: [
            purchasingUser
          ],
        } as Card;
      })
    );
  }

  getEngineReplacementDestroyedByCard(engineReplacementForm: GenEngineReplacementForm): Observable<Card> {
    return combineLatest([
      this.translationService.translate('checkoutProgress.engineReplacementForm.destroyedByText'),
      this.translationService.translate(`checkoutProgress.engineReplacementForm.destroyedByOptions.${engineReplacementForm.destructionType}`),
    ]).pipe(
      map(([textTitle, destructionType]) => {
        return {
          title: textTitle,
          text: [
            destructionType
          ],
        } as Card;
      })
    );
  }
}
